<mat-tab-group (selectedTabChange)="onTabSelected($event)" [@.disabled]="true"
  *ngIf="tabPage?.tps && tabPage.tps.length">
  <mat-tab *ngFor="let tab of tabPage.tps; let i = index" label={{tab.name}}>
    <xormon-overview-content *ngIf="tab.urlContent" [content]="tab.urlContent"></xormon-overview-content>
    <xormon-loading-indicator *ngIf="!tab.urlContent" class="stickyheaders-holder"></xormon-loading-indicator>
  </mat-tab>
</mat-tab-group>
